function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor, _descriptor2, _descriptor3, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

// eslint-disable-next-line max-classes-per-file
import { Loader } from '@googlemaps/js-api-loader';
import { Component, dataParam, register } from 'ovee.js';
import { getKey, getMapOptions } from './get-options';
var GoogleMap = (_dec = register('google-map'), _dec2 = dataParam('lat'), _dec3 = dataParam('lng'), _dec4 = dataParam('pin'), _dec(_class = (_class2 = (_temp = /*#__PURE__*/function (_Component) {
  _inherits(GoogleMap, _Component);

  var _super = _createSuper(GoogleMap);

  function GoogleMap() {
    var _this;

    _classCallCheck(this, GoogleMap);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _initializerDefineProperty(_assertThisInitialized(_this), "lat", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "lng", _descriptor2, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "pin", _descriptor3, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "loader", void 0);

    _defineProperty(_assertThisInitialized(_this), "map", void 0);

    return _this;
  }

  _createClass(GoogleMap, [{
    key: "init",
    value: function init() {
      this.pins = this.$element.querySelectorAll('[data-poi]');
      this.mapContainer = this.$element.querySelector('[data-map]');

      if (!this.mapContainer) {
        return;
      }

      this.initLoader();
      this.initMap();
    }
  }, {
    key: "initLoader",
    value: function initLoader() {
      this.loader = new Loader({
        apiKey: getKey(),
        version: 'weekly'
      });
    }
  }, {
    key: "initMap",
    value: function initMap() {
      var _this2 = this;

      if (this.map) return;
      this.loader.load().then(function (google) {
        var infoWindow = new google.maps.InfoWindow({
          disableAutoPan: true
        });
        _this2.map = new google.maps.Map(_this2.mapContainer, getMapOptions(+_this2.lat, +_this2.lng));
        var markerDot = {
          // eslint-disable-next-line max-len
          path: 'M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z',
          fillColor: 'black',
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 1,
          anchor: new google.maps.Point(10, 10)
        };
        var markerPin = {
          // eslint-disable-next-line max-len
          path: 'M17.5 0C12.8587 0 8.40689 1.8436 5.125 5.12549C1.84311 8.40737 0 12.8587 0 17.5C0 25.829 12.9999 41.1252 16.5889 45.2002C16.7026 45.33 16.8428 45.4336 17 45.5049C17.1572 45.5761 17.3274 45.6133 17.5 45.6133C17.6726 45.6133 17.8438 45.5761 18.001 45.5049C18.1582 45.4336 18.2984 45.33 18.4121 45.2002C22.0051 41.1292 35 25.833 35 17.5C35 12.8587 33.1559 8.40737 29.874 5.12549C26.5921 1.8436 22.1413 0 17.5 0V0ZM17.4121 26.0142C15.8496 26.0142 14.3216 25.5507 13.0225 24.6826C11.7233 23.8146 10.7112 22.5807 10.1133 21.1372C9.51535 19.6937 9.35826 18.1052 9.66309 16.5728C9.96791 15.0403 10.7204 13.6327 11.8252 12.5278C12.93 11.423 14.3377 10.6705 15.8701 10.3657C17.4026 10.0609 18.991 10.2175 20.4346 10.8154C21.8781 11.4134 23.1124 12.4259 23.9805 13.7251C24.8485 15.0242 25.3115 16.5518 25.3115 18.1143C25.3115 20.2095 24.4796 22.2187 22.998 23.7002C21.5165 25.1817 19.5073 26.0142 17.4121 26.0142V26.0142Z',
          fillColor: 'black',
          fillOpacity: 1,
          strokeWeight: 0,
          rotation: 0,
          scale: 1,
          anchor: new google.maps.Point(17.5, 45)
        }; // class Popup extends google.maps.OverlayView {
        // 	position;
        // 	containerDiv;
        // 	constructor(position, content) {
        // 		super();
        // 		this.position = position;
        // 		content.classList.add('popup-bubble');
        // 		// This zero-height div is positioned at the bottom of the bubble.
        // 		const bubbleAnchor = document.createElement('div');
        // 		bubbleAnchor.classList.add('popup-bubble-anchor');
        // 		bubbleAnchor.appendChild(content);
        // 		// This zero-height div is positioned at the bottom of the tip.
        // 		this.containerDiv = document.createElement('div');
        // 		this.containerDiv.classList.add('popup-container');
        // 		this.containerDiv.appendChild(bubbleAnchor);
        // 		// Optionally stop clicks, etc., from bubbling up to the map.
        // 		Popup.preventMapHitsAndGesturesFrom(this.containerDiv);
        // 	}
        // 	/** Called when the popup is added to the map. */
        // 	onAdd() {
        // 		this.getPanes().floatPane.appendChild(this.containerDiv);
        // 	}
        // 	/** Called when the popup is removed from the map. */
        // 	onRemove() {
        // 		if (this.containerDiv.parentElement) {
        // 			this.containerDiv.parentElement.removeChild(this.containerDiv);
        // 		}
        // 	}
        // 	/** Called each frame when the popup needs to draw itself. */
        // 	draw() {
        // 		const divPosition = this.getProjection().fromLatLngToDivPixel(
        // 			this.position
        // 		);
        // 		// Hide the popup when it is far out of view.
        // 		const display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000
        // 			? 'block'
        // 			: 'none';
        // 		if (display === 'block') {
        // 			this.containerDiv.style.left = `${divPosition.x}px`;
        // 			this.containerDiv.style.top = `${divPosition.y}px`;
        // 		}
        // 		if (this.containerDiv.style.display !== display) {
        // 			this.containerDiv.style.display = display;
        // 		}
        // 	}
        // }
        // eslint-disable-next-line no-new

        new google.maps.Marker({
          position: getMapOptions(+_this2.lat, +_this2.lng).center,
          map: _this2.map,
          icon: markerPin
        });

        if (_this2.pins) {
          // const popup = new Popup(
          // 	new google.maps.LatLng(this.pins[0][0]),
          // 	document.getElementById('map-bubble')
          // );
          // popup.setMap(this.map);
          _this2.pins.forEach(function (poi, i) {
            var position = {
              lat: parseFloat(poi.getAttribute('data-lat')),
              lng: parseFloat(poi.getAttribute('data-lng'))
            };
            var title = poi.innerText; // eslint-disable-next-line no-new

            var marker = new google.maps.Marker({
              position: position,
              map: _this2.map,
              title: "".concat(title),
              icon: markerDot
            });
            marker.addListener('click', function () {
              infoWindow.close();
              infoWindow.setContent(marker.getTitle());
              infoWindow.open(marker.getMap(), marker);
            });

            if (i === 0) {
              infoWindow.setContent(marker.getTitle());
              infoWindow.open(marker.getMap(), marker);
            }
          });
        }
      })["catch"]();
    }
  }]);

  return GoogleMap;
}(Component), _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "lat", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "lng", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "pin", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
export { GoogleMap as default };